import http from '@/api/http'

import {
  TCensusYearSummary,
  TGetFilesParams,
  TGetFilesResponse,
  TProcessingDetail,
  TProcessingUser,
} from './types'

export const getFiles = async (filters: TGetFilesParams) => {
  const response = await http.get<TGetFilesResponse>('prediction-processing/', {
    params: filters,
  })
  return response.data
}

export const getProcessingUsers = async () => {
  const response = await http.get<TProcessingUser[]>(
    'prediction-processing/field-values/users/'
  )
  return response.data
}

export const getCensusYearSummary = async (year: number) => {
  const response = await http.get<TCensusYearSummary>(
    `prediction-processing/census-years/${year}/`
  )
  return response.data
}

export const getProcessingDetail = async (id: number) => {
  const response = await http.get<TProcessingDetail>(
    `prediction-processing/${id}/`
  )
  return response.data
}
